import { render, staticRenderFns } from "./MemberPortrait.vue?vue&type=template&id=49ec1dc2"
import script from "./MemberPortrait.vue?vue&type=script&lang=js"
export * from "./MemberPortrait.vue?vue&type=script&lang=js"
import style0 from "./MemberPortrait.vue?vue&type=style&index=0&id=49ec1dc2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports